import React from 'react';

function Profile() {
  return (
    <div className="p-4 text-white">
      <h1 className="text-2xl font-bold">Profile</h1>
    </div>
  );
}

export default Profile;
